export function formatDeleteLineItemError(label: string, error: unknown): string {
	const detail = error instanceof Error ? error.message : "Failed to delete line item";
	return `Could not delete "${label}": ${detail}`;
}
